/**
 * New Ashford — baked by ultra_map_editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake. Edit via the editor.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "New Ashford",
  ground: { width: 64, depth: 64 },
  spawnPoint: { x: -1.070999558954238, z: -28.526745928764104 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.17, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.35, secondaryRotation: 0.5061454830783556, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.06, noiseRotation: -0.36826447217080355, noiseOffset: 0.08, noiseGain: 0.81 },

  objects: [
    {
      id: "stall-med",
      kind: "building",
      label: "Medbay",
      position: { x: 24.32923634184065, z: -3.9387332764351326 },
      size: { w: 10.8, d: 12.15, h: 5.85 },
      color: 0x6d8f6a,
      interactable: true,
      npcId: "iris",
      modelUrl: "/models/buildings/building_settlement_medbay.glb",
      collisionW: 6.48,
      collisionD: 7.29,
      rotationY: -1.4835088542776567,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.5392428789490777,
    },
    {
      id: "barracks",
      kind: "building",
      label: "Barracks",
      position: { x: 17.560553146105065, z: -21.291073813852673 },
      size: { w: 17.7408, d: 21.168, h: 5.6448 },
      color: 0x4f7a78,
      interactable: true,
      npcId: "sergeant",
      modelUrl: "/models/buildings/building_barracks.glb",
      collisionW: 11.7936,
      collisionD: 14.1526,
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: -0.4506230442568988,
    },
    {
      id: "player-home",
      kind: "building",
      label: "Your Home",
      position: { x: -16.2207, z: -21.1932 },
      size: { w: 10.22, d: 7.98, h: 4.2 },
      color: 0x8a5a3a,
      interactable: true,
      npcId: "home",
      modelUrl: "/models/buildings/building_home_lvl6.glb",
      homeLevel: 6,
      collisionW: 9.198,
      collisionD: 7.182,
      rotationY: -1.1078231530054068,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0.009385979588473425,
    },
    {
      id: "object-mtr7794c",
      kind: "building",
      label: "Building_gate_1_closed",
      position: { x: -0.1521469195711571, z: -31.090978870157414 },
      size: { w: 8.6983, d: 4.9335, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_gate_1_closed.glb",
      collisionW: 7.828,
      collisionD: 4.44,
      rotationY: 0,
      positionY: -0.035967979705384547,
    },
    {
      id: "object-mtr7c0wy",
      kind: "building",
      label: "Building_fence_1",
      position: { x: 4.335997472397295, z: -30.20677887161043 },
      size: { w: 2.9198, d: 5.726500000000001, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.628,
      collisionD: 5.154,
      rotationY: -1.5678672259281883,
      positionY: -0.06878391010642067,
    },
    {
      id: "object-mtr7desb",
      kind: "building",
      label: "Building_fence_1",
      position: { x: -4.194376606000635, z: -30.87737342863071 },
      size: { w: 2.9198, d: 5.726500000000001, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.628,
      collisionD: 5.154,
      rotationY: 1.5476510081500279,
      positionY: -0.060672789911269655,
    },
    {
      id: "object-mtr7vf37",
      kind: "building",
      label: "Building_guard_tower_1",
      position: { x: 3.775116581951954, z: -28.2074464936885 },
      size: { w: 3.7804, d: 3.7804, h: 5.720000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_guard_tower_1.glb",
      collisionW: 3.402,
      collisionD: 3.402,
      rotationY: 0,
      positionY: 0,
    },
    {
      id: "object-mtr7vhzd",
      kind: "building",
      label: "Building_guard_tower_2",
      position: { x: 29.508769535291865, z: -28.652656580626246 },
      size: { w: 3.5906000000000002, d: 3.8311, h: 5.720000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_guard_tower_2.glb",
      collisionW: 3.232,
      collisionD: 3.448,
      rotationY: -0.0159374288043629,
      positionY: 0,
    },
    {
      id: "object-mtrnpwy4",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: -17.379415134207463, z: -30.638278857677633 },
      size: { w: 1.9292, d: 30.143100000000004, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: 1.567428601538873,
      positionY: 0,
    },
    {
      id: "object-mtrnq9b0",
      kind: "building",
      label: "Building_settlement_canteen",
      position: { x: 22.43731554016065, z: 13.391475474081254 },
      size: { w: 10.2494, d: 18.6606, h: 5.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_settlement_canteen.glb",
      collisionW: 9.2246,
      collisionD: 16.7944,
      rotationY: -1.644780513054058,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: -0.26749065202474753,
    },
    {
      id: "object-mtrnthsg",
      kind: "prop",
      label: "Obj_barrel",
      position: { x: 3.2760466983883836, z: -26.290909930901506 },
      size: { w: 0.6149000000000001, d: 0.6149000000000001, h: 0.8250000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtrntsph",
      kind: "prop",
      label: "Obj_well",
      position: { x: 6.19891507632825, z: -2.309557664036108 },
      size: { w: 1.704, d: 2.166, h: 1.26 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_well.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "npc-body-toma",
      kind: "npc",
      label: "Toma",
      position: { x: 2.0558789495712215, z: -26.771591146060143 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "toma",
      npcActivity: "stand",
      heldItemKey: "shotgun",
      modelUrl: "/models/char-1.glb",
      rotationY: 0.21607476035714793,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-finch",
      kind: "npc",
      label: "Finch",
      position: { x: 5.741608260884839, z: 23.747893470069 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "finch",
      npcActivity: "aim",
      heldItemKey: "rifle_bolt",
      modelUrl: "/models/npc-survivor-3.glb",
      rotationY: 2.427647551365752,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-mtsfrqjr",
      kind: "building",
      label: "Building_watertower",
      position: { x: -9.721497799618913, z: -1.1264295505466855 },
      size: { w: 6.9495, d: 7.1382, h: 11.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_watertower.glb",
      collisionW: 6.2545,
      collisionD: 6.424,
      rotationY: 1.262067735462812,
      positionY: -0.1588831059968423,
    },
    {
      id: "grass-mtshjvzc",
      kind: "grass",
      label: "Grass Patch",
      position: { x: 13.120056397573105, z: -15.508477076528164 },
      size: { w: 0.8035964983144048, d: 0.9827955831007386, h: 0.45 },
      color: 0x2f5c28,
      interactable: false,
      rotationY: 0.16354694501720832,
      noClip: true,
      positionY: -0.12971795432376187,
    },
    {
      id: "object-mtskep5x",
      kind: "prop",
      label: "Obj_suv-destroyed",
      position: { x: -10.40399101367457, z: -3.778654666435404 },
      size: { w: 2.037, d: 4.517, h: 1.75 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_suv-destroyed.glb",
      rotationY: 0.417094136056077,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-tower-guard-gate",
      kind: "npc",
      label: "Tower Guard",
      position: { x: 4.604402200624282, z: -28.95396455418842 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcId: "tower-guard-gate",
      npcActivity: "stand",
      heldItemKey: "svd",
      modelUrl: "/models/npc-survivor-1.glb",
      rotationY: 2.359729476719179,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 3.2972689616566235,
    },
    {
      id: "object-mtsla2wz",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: -31.695403205903595, z: -15.503857389758226 },
      size: { w: 1.929, d: 30.143, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: 0.008966459337133713,
      positionY: 0,
    },
    {
      id: "object-mtslakit",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: -23.54240597229323, z: 12.279701382579816 },
      size: { w: 1.929, d: 30.143, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: 0.5279529385754916,
      positionY: 0,
    },
    {
      id: "object-mtslc87e",
      kind: "building",
      label: "Building_fence_2",
      position: { x: -14.277818783520129, z: 28.12586172927039 },
      size: { w: 9.147, d: 5.277, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_2.glb",
      collisionW: 8.232,
      collisionD: 4.749,
      rotationY: -0.8204100458059441,
      positionY: -0.03434988737079636,
    },
    {
      id: "object-mtslcbov",
      kind: "building",
      label: "Building_fence_1",
      position: { x: 27.548506811014214, z: 29.00882184176497 },
      size: { w: 2.921, d: 5.727, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.629,
      collisionD: 5.154,
      rotationY: -0.747501599210585,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.05414408368339396,
    },
    {
      id: "object-mtslcf4h",
      kind: "building",
      label: "Building_fence_2",
      position: { x: 21.973716798154765, z: 30.697984368404693 },
      size: { w: 9.147, d: 5.277, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_2.glb",
      collisionW: 8.232,
      collisionD: 4.749,
      rotationY: 0,
      positionY: -0.03415788231852712,
    },
    {
      id: "object-mtslck96",
      kind: "building",
      label: "Building_guard_tower_2",
      position: { x: -11.10198119814777, z: 27.50159024535703 },
      size: { w: 3.591, d: 3.831, h: 5.720000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_guard_tower_2.glb",
      collisionW: 3.232,
      collisionD: 3.448,
      rotationY: 0.8188704491553875,
      positionY: 0,
    },
    {
      id: "object-mtslcon2",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: 3.684389334304236, z: 30.87328743472438 },
      size: { w: 1.929, d: 30.143, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: -1.5608257971685249,
      positionY: 0,
    },
    {
      id: "object-mtslfyxs",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: 30.60024512381567, z: 11.99052670679836 },
      size: { w: 1.929, d: 30.143, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: -0.09776142411018844,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtslgtj5",
      kind: "building",
      label: "Building_fence_3-long",
      position: { x: 31.88013865806567, z: -16.780725808360437 },
      size: { w: 1.929, d: 30.143, h: 4.992 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_3-long.glb",
      collisionW: 1.736,
      collisionD: 27.129,
      rotationY: 0,
      positionY: 0,
    },
    {
      id: "object-mtslhvmf",
      kind: "building",
      label: "Building_fence_2",
      position: { x: 27.790631519478698, z: -31.22521020834509 },
      size: { w: 9.147, d: 5.277, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_2.glb",
      collisionW: 8.232,
      collisionD: 4.749,
      rotationY: 0,
      positionY: -0.22594921802505663,
    },
    {
      id: "object-mtsli5lo",
      kind: "building",
      label: "Building_fence_1",
      position: { x: 22.350603431800014, z: -30.82615412816774 },
      size: { w: 2.921, d: 5.727, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.629,
      collisionD: 5.154,
      rotationY: -1.537400898366185,
      positionY: -0.05101740741312355,
    },
    {
      id: "object-mtsliin3",
      kind: "building",
      label: "Building_fence_1",
      position: { x: 18.243771156053356, z: -31.67619932743107 },
      size: { w: 2.921, d: 5.727, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.629,
      collisionD: 5.154,
      rotationY: 1.5302352167234368,
      positionY: -0.060752673275832336,
    },
    {
      id: "object-mtsliktt",
      kind: "building",
      label: "Building_fence_2",
      position: { x: 9.541477581916983, z: -30.502073300885566 },
      size: { w: 9.147, d: 5.277, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_2.glb",
      collisionW: 8.232,
      collisionD: 4.749,
      rotationY: 0,
      positionY: -0.04087227575038899,
    },
    {
      id: "object-mtslipem",
      kind: "building",
      label: "Building_fence_1",
      position: { x: 14.508032135509987, z: -30.651126428206357 },
      size: { w: 2.921, d: 5.727, h: 4.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_fence_1.glb",
      collisionW: 2.629,
      collisionD: 5.154,
      rotationY: -1.565225272694109,
      positionY: -0.09111503891442752,
    },
    {
      id: "object-mtvf26rs",
      kind: "prop",
      label: "Tractor_old",
      position: { x: 29.190176846907583, z: 6.543149125902254 },
      size: { w: 2.396, d: 5.456, h: 2.7 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tractor_old.glb",
      rotationY: 3.1151930167082993,
      rotationX: -1.2246467991473537e-16,
      rotationZ: 1.2246467991473537e-16,
      positionY: 0.004428455414446031,
    },
    {
      id: "object-mtvfxlu5",
      kind: "prop",
      label: "Crates",
      position: { x: -7.878845205943829, z: 1.8650032889767036 },
      size: { w: 2.002, d: 1.906, h: 1.1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtvgx46i",
      kind: "building",
      label: "Settlement_market",
      position: { x: -4.315687250786578, z: -6.534592337068943 },
      size: { w: 7.589, d: 4.645, h: 4 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "marek",
      modelUrl: "/models/buildings/building_settlement_market.glb",
      collisionW: 6.83,
      collisionD: 4.18,
      rotationY: 1.0102021519055386,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "npc-body-halvard",
      kind: "npc",
      label: "Halvard",
      position: { x: -8.9, z: -4.6 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "halvard",
      npcActivity: "stand",
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 2.1,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-marek",
      kind: "npc",
      label: "Old Marek",
      position: { x: -4.321074339870784, z: -5.129284628352364 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "marek",
      npcActivity: "stand",
      modelUrl: "/models/char-3.glb",
      rotationY: 0.926622122494803,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-bram",
      kind: "npc",
      label: "Bram",
      position: { x: 18.711615709119158, z: -5.623440000900887 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "bram",
      npcActivity: "stand",
      modelUrl: "/models/char-1.glb",
      rotationY: -0.8209334247549583,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-oksana",
      kind: "npc",
      label: "Oksana",
      position: { x: -8.549467226849412, z: 4.303507633008377 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "oksana",
      npcActivity: "stand",
      modelUrl: "/models/char-2.glb",
      rotationY: 0.7651027300005065,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-rask",
      kind: "npc",
      label: "Elder Rask",
      position: { x: 5, z: 3 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "rask",
      npcActivity: "stand",
      modelUrl: "/models/char-4.glb",
      rotationY: -2,
      noClip: true,
    },
    {
      id: "object-church",
      kind: "building",
      label: "Church",
      position: { x: 19.555299421687355, z: 5.498588173565971 },
      size: { w: 9.906, d: 9.297, h: 9.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_church.glb",
      collisionW: 8.915,
      collisionD: 8.367,
      rotationY: -0.08695459886165893,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: -0.21565537891012632,
    },
    {
      id: "object-overseer-house",
      kind: "building",
      label: "Settlement Overseer House",
      position: { x: 1.244541379246515, z: 13.551725774721454 },
      size: { w: 9.8336, d: 7.8148, h: 10.08 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_settlement-overseer_house.glb",
      collisionW: 8.8508,
      collisionD: 7.0336,
      rotationY: -2.6418613066904966,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-weapons-stall",
      kind: "building",
      label: "Settlement Weapons Stall",
      position: { x: -8.429850933876924, z: 4.251433126445413 },
      size: { w: 4.4194, d: 3.0499, h: 3.39 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_settlement-weapons_stall.glb",
      collisionW: 3.9776,
      collisionD: 2.7448,
      rotationY: 0.7773041989831033,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0.00546902253803605,
    },
    {
      id: "object-generator",
      kind: "prop",
      label: "Large Generator",
      position: { x: 9.83746743674475, z: 26.692091395322645 },
      size: { w: 3.103, d: 2.67, h: 2.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-large.glb",
      collisionW: 2.793,
      collisionD: 2.403,
      rotationY: -0.03949161439111113,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-shack-a",
      kind: "building",
      label: "Shack — Sleeping Corners",
      position: { x: -27.506034371398737, z: -4.201622144151622 },
      size: { w: 6.8222, d: 9.464, h: 4.48 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_a.glb",
      collisionW: 6.1404,
      collisionD: 8.5176,
      rotationY: 0.1995933283856601,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-shack-weathered",
      kind: "building",
      label: "Lean-to — Sleeping Corners",
      position: { x: -21.32359904245924, z: -0.15867849968906395 },
      size: { w: 6.426, d: 5.3578, h: 3.92 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_weathered.glb",
      collisionW: 5.7834,
      collisionD: 4.8216,
      rotationY: 2.642030205889753,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-shack-b",
      kind: "building",
      label: "Shack — Sleeping Corners",
      position: { x: -11.618705733143955, z: -9.004144894652345 },
      size: { w: 8.3314, d: 6.8278, h: 4.76 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_b.glb",
      collisionW: 7.4984,
      collisionD: 6.1446,
      rotationY: -1.8965645624524556,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-shack-c",
      kind: "building",
      label: "Shack — Sleeping Corners",
      position: { x: -22.90425808446955, z: 7.48714889795086 },
      size: { w: 5.7022, d: 5.8814, h: 5.04 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_c.glb",
      collisionW: 5.1324,
      collisionD: 5.2934,
      rotationY: 2.116622171346118,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-shack-wooden",
      kind: "building",
      label: "Shack — Sleeping Corners",
      position: { x: -2.4319, z: 28.4552750062603 },
      size: { w: 5.3648, d: 7.0448, h: 4.76 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_wooden.glb",
      collisionW: 4.8286,
      collisionD: 6.3406,
      rotationY: -0.07354355065406665,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-house-dilapidated",
      kind: "building",
      label: "Old Ashford House",
      position: { x: -24.781917715463255, z: -15.145801785478548 },
      size: { w: 8.841, d: 10.9662, h: 5.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_house_dilapidated.glb",
      collisionW: 7.9576,
      collisionD: 9.87,
      rotationY: 0.8553959301294982,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-farm",
      kind: "building",
      label: "Ashford Farm",
      position: { x: -14.826407407878328, z: 16.93268270429046 },
      size: { w: 17.1584, d: 10.9676, h: 5.88 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_farm.glb",
      collisionW: 15.442,
      collisionD: 9.8714,
      rotationY: 2.062634904445828,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-shooting-range",
      kind: "building",
      label: "Shooting Range",
      position: { x: 3.16978941415863, z: 26.718554137407736 },
      size: { w: 5.251, d: 8.198, h: 3.2 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_shooting_range.glb",
      collisionW: 4.726,
      collisionD: 7.378,
      rotationY: 3.141593,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-repair-shop",
      kind: "building",
      label: "Repair Shop",
      position: { x: 18.595293006088433, z: 25.6993709957147 },
      size: { w: 8.3692, d: 6.0914, h: 5.32 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_repair_shop.glb",
      collisionW: 7.532,
      collisionD: 5.4824,
      rotationY: -1.695727914452003,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-workshop",
      kind: "building",
      label: "Workshop",
      position: { x: 24.318624601380694, z: 23.734879699419704 },
      size: { w: 6.6696, d: 8.3608, h: 4.76 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_workshop.glb",
      collisionW: 6.0032,
      collisionD: 7.525,
      rotationY: -1.838797736289877,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-campfire",
      kind: "prop",
      label: "Campfire",
      position: { x: -2.5, z: 3.6 },
      size: { w: 4.64, d: 4.29, h: 1.885 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_campfire-pit.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-chair-wood",
      kind: "prop",
      label: "Chair Wood",
      position: { x: -0.3433, z: 5.7567 },
      size: { w: 0.9, d: 0.9, h: 0.9 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-wood.glb",
      rotationY: -2.2,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-cushion-1",
      kind: "prop",
      label: "Cushion 1",
      position: { x: -0.43461603453292974, z: 1.7117071316894295 },
      size: { w: 1.035, d: 1.158, h: 0.35 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 0.6987599502240258,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-kettle",
      kind: "prop",
      label: "Kettle",
      position: { x: -2.9, z: 2.5 },
      size: { w: 0.3, d: 0.3, h: 0.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_kettle.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-pot-iron",
      kind: "prop",
      label: "Pot Iron",
      position: { x: -1.6, z: 4.3 },
      size: { w: 0.4, d: 0.4, h: 0.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_pot-iron.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-lantern-oil",
      kind: "prop",
      label: "Lantern Oil",
      position: { x: -4.6, z: 2.7 },
      size: { w: 0.35, d: 0.35, h: 0.35 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-bell-camp",
      kind: "prop",
      label: "Bell Camp",
      position: { x: 6.5, z: 10 },
      size: { w: 1.6, d: 1.6, h: 1.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bell-camp.glb",
      rotationY: 0.3,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-signpost",
      kind: "prop",
      label: "Signpost",
      position: { x: 6.912941634880637, z: -11.489212172393737 },
      size: { w: 2.4, d: 2.4, h: 2.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_signpost.glb",
      rotationY: -0.5255498988878765,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-crate-wood-1",
      kind: "prop",
      label: "Crate Wood 1",
      position: { x: 8.254927006937676, z: 0.22690792105837376 },
      size: { w: 0.8, d: 0.8, h: 0.8 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.2,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-crate-milk",
      kind: "prop",
      label: "Crate Milk",
      position: { x: 9.287216603380394, z: -4.163302940355674 },
      size: { w: 0.5, d: 0.5, h: 0.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: -0.8,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-cans-pyramid",
      kind: "prop",
      label: "Cans Pyramid",
      position: { x: 3.4, z: -2.2 },
      size: { w: 0.5, d: 0.5, h: 0.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-pans-stack",
      kind: "prop",
      label: "Pans Stack",
      position: { x: 8.629953813736561, z: -4.129364025833176 },
      size: { w: 0.4, d: 0.4, h: 0.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-board-chopping",
      kind: "prop",
      label: "Board Chopping",
      position: { x: 21.46604218008444, z: -6.560284502860217 },
      size: { w: 0.8, d: 0.8, h: 0.8 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 1.4,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-utility-post-1",
      kind: "prop",
      label: "Utility Post 1",
      position: { x: -7.2, z: -11.5 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.1,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-utility-post-2",
      kind: "prop",
      label: "Utility Post 2",
      position: { x: -2.8, z: -19.5 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.1,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-utility-post-3",
      kind: "prop",
      label: "Utility Post 3",
      position: { x: 8.6, z: -25.5 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: -0.2,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-utility-post-4",
      kind: "prop",
      label: "Utility Post 4",
      position: { x: 13.5, z: 9.5 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.3,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-generator-diesel",
      kind: "prop",
      label: "Generator Diesel",
      position: { x: 20.11716596158348, z: 1.116288027437351 },
      size: { w: 1.12, d: 1.019, h: 1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-diesel.glb",
      rotationY: 0.7,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-tyre-pile-1",
      kind: "prop",
      label: "Tyre Pile 1",
      position: { x: -27.537517375506848, z: 0.37937305830652335 },
      size: { w: 1, d: 1, h: 1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: -0.10258689001408872,
    },
    {
      id: "object-tyre-pile-2",
      kind: "prop",
      label: "Tyre Pile 2",
      position: { x: 28.76181408155989, z: 19.438583017915597 },
      size: { w: 1, d: 1, h: 1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: -1.7974492898283725,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-dumpster-1",
      kind: "prop",
      label: "Dumpster 1",
      position: { x: -7.035781137510284, z: -3.278816543505261 },
      size: { w: 1.4, d: 1.4, h: 1.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: -0.5340041395835005,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-wheelbarrow-1",
      kind: "prop",
      label: "Wheelbarrow 1",
      position: { x: -12.871788929644413, z: 11.722540397694122 },
      size: { w: 0.7, d: 0.7, h: 0.7 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow.glb",
      rotationY: 2.1,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-toolbox-1",
      kind: "prop",
      label: "Toolbox 1",
      position: { x: 16.5, z: 11.5 },
      size: { w: 0.4, d: 0.4, h: 0.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-tool-rack",
      kind: "prop",
      label: "Tool Rack",
      position: { x: 16.041947516906315, z: 18.446846310686592 },
      size: { w: 1.6, d: 1.6, h: 1.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tool-rack.glb",
      rotationY: -0.4,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-rope-coil",
      kind: "prop",
      label: "Rope Coil",
      position: { x: 17.4, z: 18.6 },
      size: { w: 0.4, d: 0.4, h: 0.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-fence-wire-1",
      kind: "prop",
      label: "Fence Wire 1",
      position: { x: -10.5, z: 24.5 },
      size: { w: 1.6, d: 1.6, h: 1.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.1,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-stump-roots",
      kind: "prop",
      label: "Stump Roots",
      position: { x: -21.5, z: 15.5 },
      size: { w: 0.7, d: 0.7, h: 0.7 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-spade",
      kind: "prop",
      label: "Spade",
      position: { x: -13.64828270561961, z: 12.584778099467137 },
      size: { w: 1.2, d: 1.2, h: 1.2 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 1.1,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-rake-2",
      kind: "prop",
      label: "Rake 2",
      position: { x: -2.6, z: 17.2 },
      size: { w: 1.4, d: 1.4, h: 1.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: -0.9,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-blocks-stack",
      kind: "prop",
      label: "Blocks Stack",
      position: { x: 14.8, z: 16.2 },
      size: { w: 0.6, d: 0.6, h: 0.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-books-stack",
      kind: "prop",
      label: "Books Stack",
      position: { x: 5.087277351648791, z: 10.562832560987424 },
      size: { w: 0.35, d: 0.35, h: 0.35 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-chair-broken",
      kind: "prop",
      label: "Chair Broken",
      position: { x: -21.5, z: 13.5 },
      size: { w: 0.9, d: 0.9, h: 0.9 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 2,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-carseat-1",
      kind: "prop",
      label: "Carseat 1",
      position: { x: -8.600243075065347, z: 24.1621071697376 },
      size: { w: 1.09, d: 1.09, h: 1.09 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.5839756761356205,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-fire-barrel-1",
      kind: "prop",
      label: "Fire Barrel 1",
      position: { x: -20.97269394025047, z: 10.638135635018319 },
      size: { w: 0.9, d: 0.9, h: 0.9 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-fire-barrel-2",
      kind: "prop",
      label: "Fire Barrel 2",
      position: { x: 4.806649030231698, z: -23.072013808249526 },
      size: { w: 0.9, d: 0.9, h: 0.9 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-bucket-metal",
      kind: "prop",
      label: "Bucket Metal",
      position: { x: -9.358943804439576, z: 3.0919549787884337 },
      size: { w: 0.35, d: 0.35, h: 0.35 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-crates-3",
      kind: "prop",
      label: "Crates 3",
      position: { x: 25.936632231687653, z: -15.075723129228358 },
      size: { w: 1.1, d: 1.1, h: 1.1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.4,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-barrel-2",
      kind: "prop",
      label: "Barrel 2",
      position: { x: 21, z: 22.5 },
      size: { w: 0.55, d: 0.55, h: 0.55 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-sleeping-bag-1",
      kind: "prop",
      label: "Sleeping Bag 1",
      position: { x: -20.41311089760365, z: 0.9199760909105459 },
      size: { w: 1.701, d: 0.812, h: 0.25 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: -0.7059988617034041,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-sleeping-bag-2",
      kind: "prop",
      label: "Sleeping Bag 2",
      position: { x: -21.932445047121988, z: 9.56633051187307 },
      size: { w: 1.701, d: 0.812, h: 0.25 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: -2.960217419553981,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-scrap-1",
      kind: "prop",
      label: "Item Scrap 1",
      position: { x: -28.020854217249685, z: -7.777742800822635 },
      size: { w: 0.3, d: 0.3, h: 0.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-scrap-2",
      kind: "prop",
      label: "Item Scrap 2",
      position: { x: -27.61700301289879, z: -0.49509465831186106 },
      size: { w: 0.3, d: 0.3, h: 0.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-tarp",
      kind: "prop",
      label: "Item Tarp",
      position: { x: -7.198815911204021, z: 26.46633909176542 },
      size: { w: 0.3, d: 0.3, h: 0.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_tarp-folded.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-screwdriver",
      kind: "prop",
      label: "Item Screwdriver",
      position: { x: 16, z: 13.5 },
      size: { w: 0.3, d: 0.3, h: 0.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_screwdriver-set.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-backpack-hiking",
      kind: "prop",
      label: "Item Backpack Hiking",
      position: { x: -21.553709061863962, z: 0.16974731985199343 },
      size: { w: 0.5, d: 0.5, h: 0.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_backpack-hiking.glb",
      rotationY: -1.9297572733199206,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-item-backpack-duffel",
      kind: "prop",
      label: "Item Backpack Duffel",
      position: { x: 12, z: 18.5 },
      size: { w: 0.5, d: 0.5, h: 0.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_backpack-duffel.glb",
      rotationY: -0.7,
      noClip: true,
      positionY: 0,
    },
    {
      id: "npc-body-yulia",
      kind: "npc",
      label: "Yulia",
      position: { x: -14.765990284868757, z: 11.215988070077847 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "yulia",
      npcActivity: "work",
      heldItemKey: "rake",
      modelUrl: "/models/npc-farmer.glb",
      rotationY: -1.0950747223619866,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-farm",
      kind: "npc",
      label: "Citizen Farm",
      position: { x: 3.8662785369531143, z: -0.47638372234122883 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "walk",
      wanderRadius: 5.5,
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "wreck-gate-w1",
      kind: "prop",
      label: "Army Truck — Gate Barricade",
      position: { x: -10.06932027987727, z: -28.903214350268218 },
      size: { w: 3.056, d: 7.2, h: 2.81 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-45-army.glb",
      collisionW: 2.75,
      collisionD: 6.48,
      rotationY: 1.5569317002759278,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-gate-w2",
      kind: "prop",
      label: "Rusted Sedan — Gate Barricade",
      position: { x: -15.817187801350345, z: -28.19924319835206 },
      size: { w: 2.031, d: 4.4, h: 1.464 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-3.glb",
      collisionW: 1.828,
      collisionD: 3.96,
      rotationY: -0.7086315476556271,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-gate-e1",
      kind: "prop",
      label: "Army Truck — Gate Barricade",
      position: { x: 7.6847738303146285, z: -22.17846033953778 },
      size: { w: 6.624, d: 3.20068, h: 3.08384 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-39-army.glb",
      collisionW: 5.9616,
      collisionD: 2.88052,
      rotationY: 0.6906594282440074,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-gate-e2",
      kind: "prop",
      label: "Rusted Sedan — Gate Barricade",
      position: { x: 2.5939642558016267, z: -20.251393155881157 },
      size: { w: 2.2171, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-20.glb",
      collisionW: 1.9956,
      collisionD: 4.4748,
      rotationY: -0.18117336218223964,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-gate-bus",
      kind: "prop",
      label: "Bus Hulk — South Barricade",
      position: { x: -29.822272177566592, z: -24.644151278269167 },
      size: { w: 3.702, d: 11, h: 3.648 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-51-bus.glb",
      collisionW: 3.332,
      collisionD: 9.9,
      rotationY: -0.06635552393878996,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-approach-1",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 6.982002241488736, z: -16.40060895427335 },
      size: { w: 3.738, d: 4.972, h: 1.5379 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-1.glb",
      collisionW: 3.364,
      collisionD: 4.4748,
      rotationY: 0.45,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: -0.05988021314085268,
    },
    {
      id: "wreck-approach-2",
      kind: "prop",
      label: "Rusted Taxi",
      position: { x: 4.0553411048902115, z: -14.263993221441739 },
      size: { w: 2.0329, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      collisionW: 1.8295,
      collisionD: 4.4748,
      rotationY: 0.16023563306575847,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-approach-3",
      kind: "prop",
      label: "Rusted Pickup",
      position: { x: 9.24312694721165, z: -8.409980411830045 },
      size: { w: 2.377, d: 5.4, h: 2.029 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-62-pickup.glb",
      collisionW: 2.139,
      collisionD: 4.86,
      rotationY: 1.35,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-west-1",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -24.460242340999702, z: -11.325500646270317 },
      size: { w: 1.9827, d: 3.96, h: 1.5534 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-31.glb",
      collisionW: 1.7847,
      collisionD: 3.564,
      rotationY: 1.1,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-west-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -26.35850489091101, z: -2.56679916767759 },
      size: { w: 2.0182, d: 4.972, h: 1.3842 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-55.glb",
      collisionW: 1.8159,
      collisionD: 4.4748,
      rotationY: 1.7211757077266316,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-west-3",
      kind: "prop",
      label: "Rusted Van",
      position: { x: -18.826938230191647, z: -30.02327697819366 },
      size: { w: 2.7753, d: 5.72, h: 2.4783 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      collisionW: 2.4981,
      collisionD: 5.148,
      rotationY: 1.7600601633864406,
      rotationX: 5.551115123125783e-17,
      rotationZ: 1.5707963267948966,
      positionY: 1.009487,
    },
    {
      id: "wreck-east-1",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 26.163882747766095, z: -27.965086769463586 },
      size: { w: 2.491, d: 4.4, h: 1.683 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-59.glb",
      collisionW: 2.242,
      collisionD: 3.96,
      rotationY: -0.63420645805353,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-east-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 29.66518248285528, z: -23.199567061300687 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.673,
      collisionD: 3.96,
      rotationY: 0.5,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-north-1",
      kind: "prop",
      label: "Rusted Lorry",
      position: { x: 8.96063616243794, z: 28.80253212233736 },
      size: { w: 3.099, d: 7.2, h: 3.38 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-46-lorry.glb",
      collisionW: 2.789,
      collisionD: 6.48,
      rotationY: -1.5653085040525865,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-north-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 22.47434222615395, z: 22.88402562761874 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.693,
      collisionD: 3.96,
      rotationY: 0.4533465851629533,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-inner-1",
      kind: "prop",
      label: "Rusted Cabriolet",
      position: { x: -5.337700895262991, z: 23.931690959203685 },
      size: { w: 1.89, d: 4.2, h: 1.709 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-29-cabrio.glb",
      collisionW: 1.701,
      collisionD: 3.78,
      rotationY: -0.07030639151645827,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "wreck-inner-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 13.1354, z: 22.3428 },
      size: { w: 4.972, d: 3.903, h: 1.4893 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-5.glb",
      collisionW: 4.4748,
      collisionD: 3.5132,
      rotationY: 2.980844552507142,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.08141992891872718,
    },
    {
      id: "citizen-plaza-1",
      kind: "npc",
      label: "Townsfolk — Errands",
      position: { x: -5.624612842604504, z: -1.9960610265763492 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "stand",
      routine: { steps: [{ position: { x: 22.4, z: -9.4 }, activity: "stand", dwell: 100, facing: 0.7854 }, { position: { x: -1, z: 5 }, activity: "sit", dwell: 170, facing: -2.3217 }, { position: { x: -6.6, z: 2.2 }, activity: "stand", dwell: 25, facing: 1.8494 }, { position: { x: -4.6, z: 19 }, activity: "work", dwell: 180 }] },
      modelUrl: "/models/npc-civ-1.glb",
      rotationY: 0.7854,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-patrol",
      kind: "npc",
      label: "Militia Patrol",
      position: { x: -1.8479180518341458, z: -14.666149800136221 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      displayName: "Guard",
      npcActivity: "stand",
      heldItemKey: "scar",
      routine: { steps: [{ position: { x: 0, z: -16 }, activity: "stand", dwell: 20 }, { position: { x: 14, z: -14 }, activity: "aim", dwell: 15 }, { position: { x: 22, z: -2 }, activity: "stand", dwell: 20 }, { position: { x: 16, z: 10 }, activity: "stand", dwell: 15 }, { position: { x: 2, z: 16 }, activity: "aim", dwell: 15 }, { position: { x: -12, z: 8 }, activity: "stand", dwell: 20 }, { position: { x: -13, z: -6 }, activity: "stand", dwell: 15 }], speed: 1.9 },
      modelUrl: "/models/npc-survivor-2.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-guard-relay",
      kind: "npc",
      label: "Watch Relay",
      position: { x: 6.772246638743424, z: -21.544879701558 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sit",
      heldItemKey: "rifle_bolt",
      modelUrl: "/models/npc-survivor-4.glb",
      rotationY: 0.9410326616413844,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 2.889952398879432,
    },
    {
      id: "rt-sleeper",
      kind: "npc",
      label: "Sleeping Off a Shift",
      position: { x: -20.467922745165428, z: 0.9782302524495341 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sleep",
      routine: { steps: [{ position: { x: -15.2, z: -1.2 }, activity: "sleep", dwell: 240, facing: 1.5708 }, { position: { x: -14.6, z: -3.4 }, activity: "stand", dwell: 40, facing: 1.0463 }] },
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 0.15248027059057803,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-gossip-a",
      kind: "npc",
      label: "Market Gossip",
      position: { x: -6.6, z: -4.6 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "stand",
      routine: { steps: [{ position: { x: -6.6, z: -4.6 }, activity: "stand", dwell: 150, facing: 2.3562 }, { position: { x: -6.9, z: -4.2 }, activity: "stand", dwell: 120, facing: 2.3932 }] },
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: 2.3562,
      noClip: true,
    },
    {
      id: "rt-gossip-b",
      kind: "npc",
      label: "Market Gossip",
      position: { x: -0.07987133357065268, z: -8.809991885170398 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "stand",
      routine: { steps: [{ position: { x: -4.6, z: -4.4 }, activity: "stand", dwell: 130, facing: -2.4469 }, { position: { x: -4.3, z: -4.8 }, activity: "stand", dwell: 140, facing: -2.1225 }] },
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: -0.3406481921843588,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-gossip-c",
      kind: "npc",
      label: "Market Gossip",
      position: { x: -5.6, z: -6.6 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "stand",
      routine: { steps: [{ position: { x: -5.6, z: -6.6 }, activity: "stand", dwell: 160, facing: 0 }, { position: { x: -5.9, z: -6.9 }, activity: "stand", dwell: 110, facing: 0.1244 }] },
      modelUrl: "/models/npc-survivor-6.glb",
      rotationY: 0,
      noClip: true,
    },
    {
      id: "rt-customer",
      kind: "npc",
      label: "Trading with Marek",
      position: { x: -0.89756810785489, z: -7.500215388828991 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "stand",
      routine: { steps: [{ position: { x: -1.4, z: -9.8 }, activity: "stand", dwell: 150, facing: -0.0555 }, { position: { x: -2.6, z: -11.4 }, activity: "stand", dwell: 60, facing: -0.3395 }] },
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 2.287383361061896,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-mechanic-gen",
      kind: "npc",
      label: "Mechanic — Generator",
      position: { x: 19.305172642469994, z: 0.28983812977860257 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "work",
      routine: { steps: [{ position: { x: 14.4, z: 2.2 }, activity: "work", dwell: 200, facing: -1.249 }, { position: { x: 15.6, z: 0.4 }, activity: "stand", dwell: 45, facing: -0.8288 }] },
      modelUrl: "/models/npc-survivor-7.glb",
      rotationY: 2.3566258214962343,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "rt-mechanic-tractor",
      kind: "npc",
      label: "Salvaging the Tractor",
      position: { x: 27.434834333661033, z: 7.593544790627739 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "work",
      routine: { steps: [{ position: { x: 28.4, z: -12 }, activity: "work", dwell: 220, facing: 1.8301 }, { position: { x: 27.6, z: -10.2 }, activity: "stand", dwell: 50, facing: 2.2698 }] },
      modelUrl: "/models/npc-survivor-8.glb",
      rotationY: 1.4652064258605755,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-plaza-2",
      kind: "npc",
      label: "Sweeping the Square",
      position: { x: -9.226341011301969, z: 25.676882193260063 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "work",
      heldItemKey: "rake",
      routine: { steps: [{ position: { x: 6, z: 8 }, activity: "work", dwell: 90 }, { position: { x: 2.5, z: 6.5 }, activity: "work", dwell: 90 }, { position: { x: -0.5, z: 8.5 }, activity: "work", dwell: 90 }, { position: { x: 3, z: 11 }, activity: "work", dwell: 90 }], speed: 1.2 },
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: -2.191224500699858,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-craft",
      kind: "npc",
      label: "Range Practice",
      position: { x: 2.9412860132367413, z: 23.061480167129563 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "aim",
      heldItemKey: "rifle_bolt",
      routine: { steps: [{ position: { x: 10, z: 21.8 }, activity: "aim", dwell: 120, facing: 0 }, { position: { x: 11.6, z: 21.6 }, activity: "stand", dwell: 60, facing: 0 }] },
      modelUrl: "/models/npc-survivor-6.glb",
      rotationY: 3.077722509813954,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-corners-1",
      kind: "npc",
      label: "Fireside",
      position: { x: -2.973118543114912, z: 2.07494807690336 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sit",
      routine: { steps: [{ position: { x: -0.9, z: 2.3 }, activity: "sit", dwell: 200, facing: -0.8885 }, { position: { x: -0.4, z: 1.6 }, activity: "stand", dwell: 40, facing: -0.8098 }] },
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: 0.20548132177185635,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-corners-2",
      kind: "npc",
      label: "Fireside",
      position: { x: -4.289400586323428, z: 4.111380713682952 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sit",
      routine: { steps: [{ position: { x: -4.1, z: 4.9 }, activity: "sit", dwell: 230, facing: 2.2531 }, { position: { x: -4.7, z: 5.6 }, activity: "stand", dwell: 35, facing: 2.3086 }] },
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 1.7704144882395783,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "citizen-gate",
      kind: "npc",
      label: "Chatting to the Gate Guard",
      position: { x: 2.51109874849635, z: -24.64316715036268 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      displayName: "Survivor",
      npcActivity: "stand",
      routine: { steps: [{ position: { x: 3.2, z: -27.6 }, activity: "stand", dwell: 170, facing: 2.338 }, { position: { x: 1.6, z: -25.8 }, activity: "stand", dwell: 70, facing: 2.3806 }] },
      modelUrl: "/models/npc-survivor-7.glb",
      rotationY: 3.129838671970094,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pole-grid-grid-trunk-4-1",
      kind: "prop",
      label: "Utility Post",
      position: { x: 5.188661923176424, z: 0.7096042117972812 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.6396593456398811,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pole-grid-grid-trunk-5-1",
      kind: "prop",
      label: "Utility Post",
      position: { x: 1.4384, z: 19.1588 },
      size: { w: 1.55, d: 2.156, h: 4.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-mtwzsot3",
      kind: "prop",
      label: "Heli-rusted",
      position: { x: -25.831625455269034, z: 21.370407551941767 },
      size: { w: 11.304, d: 8.72, h: 4.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_heli-rusted.glb",
      rotationY: 0.34856621049147773,
      rotationX: -3.037026144447035,
      rotationZ: -3.0713332561409303,
      positionY: 0,
    },
    {
      id: "object-mu2mqw18",
      kind: "prop",
      label: "Car-rust-57-ambulance",
      position: { x: 29.74601864206953, z: -10.433555292893155 },
      size: { w: 2.323, d: 5.55, h: 2.6 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-57-ambulance.glb",
      rotationY: 0.37252317996296797,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "npc-body-test-weps1",
      kind: "npc",
      label: "test-weps1",
      position: { x: -6.981457146181452, z: -23.88416777491895 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: true,
      npcId: "test-weps1",
      npcActivity: "stand",
      heldItemKey: "mp5",
      modelUrl: "/models/npc-survivor-1.glb",
      noClip: true,
    },
  ],

  collisionZones: [
    {
      id: "zone-mt1zu8t5",
      label: "New Zone",
      position: { x: 22.545254257074532, z: -4.3591651533312366 },
      size: { w: 4.883191799759279, d: 7.292183522406286 },
      rotationY: 0.05227390547975414,
    },
    {
      id: "zone-mt1zvz3r",
      label: "New Zone",
      position: { x: 22.01533852489676, z: -0.39355874715003836 },
      size: { w: 2.8299747531226593, d: 3 },
      rotationY: 0.05610921401780993,
    },
    {
      id: "zone-mt201ips",
      label: "New Zone",
      position: { x: 19.647173802509926, z: -4.803283531274415 },
      size: { w: 0.99475902710692, d: 0.3343439046202368 },
      rotationY: 0.5442816500415202,
    },
    {
      id: "zone-mtr2nks3",
      label: "New Zone",
      position: { x: 17.571052265697436, z: -16.05591849001695 },
      size: { w: 7.644721750925382, d: 3 },
      rotationY: 0,
    },
    {
      id: "zone-mtr2o8mx",
      label: "New Zone",
      position: { x: 18.65070454696907, z: -20.612083400034006 },
      size: { w: 1.1132993359046783, d: 1.015784384453705 },
      rotationY: 0,
    },
    {
      id: "zone-mtr2okj5",
      label: "New Zone",
      position: { x: 16.09937844141926, z: -29.93487375892917 },
      size: { w: 5.547605349350552, d: 0.9219561028517804 },
      rotationY: 0,
    },
    {
      id: "zone-mtr789ku",
      label: "New Zone",
      position: { x: 0.007647347122373249, z: -30.68032733007013 },
      size: { w: 64.0352006145153, d: 0.6597778294559558 },
      rotationY: 0,
    },
    {
      id: "zone-mtskfebx",
      label: "New Zone",
      position: { x: 12.235066421841909, z: -19.744503898219552 },
      size: { w: 2.661878881501793, d: 7.128901446845072 },
      rotationY: 0,
    },
    {
      id: "zone-mtskgbud",
      label: "New Zone",
      position: { x: 19.29775419729714, z: -19.93670024790143 },
      size: { w: 12.03876871473405, d: 5.255409204523555 },
      rotationY: 0,
    },
    {
      id: "zone-mtskhlva",
      label: "New Zone",
      position: { x: 1.2685268771630187, z: -31.58592275191976 },
      size: { w: 60.42207431251919, d: 1.1976689171200718 },
      rotationY: 0,
      fog: { color: 9083546, opacity: 0.32, height: 1.5 },
    },
    {
      id: "zone-mtskjbab",
      label: "New Zone",
      position: { x: -9.178159144710415, z: -0.6772269382233325 },
      size: { w: 3, d: 3 },
      rotationY: -1.1939865408065802,
    },
    {
      id: "zone-mtskjyjt",
      label: "New Zone",
      position: { x: -10.556518929823898, z: -3.9151667795417424 },
      size: { w: 3.801345941761406, d: 1.4892153656548863 },
      rotationY: -1.154369689053444,
    },
    {
      id: "zone-range-shed",
      label: "Range shed (solid)",
      position: { x: 9.760515037902728, z: 27.107290979197753 },
      size: { w: 2.969418223791078, d: 3.3 },
      rotationY: 0,
    },
    {
      id: "zone-mu2mdry1",
      label: "New Zone",
      position: { x: 8.099258702160451, z: -25.567315336571454 },
      size: { w: 0.5548880776541788, d: 0.38431629393741595 },
      rotationY: 0,
    },
    {
      id: "zone-mu2me83i",
      label: "New Zone",
      position: { x: 3.6934732782780593, z: -28.363578239161722 },
      size: { w: 3, d: 3 },
      rotationY: 0,
    },
    {
      id: "zone-mu2mo32n",
      label: "New Zone",
      position: { x: 15.287846724091565, z: 6.296144221289062 },
      size: { w: 1.2743346238225068, d: 3 },
      rotationY: -0.10515069824765572,
    },
    {
      id: "zone-mu2mojyh",
      label: "New Zone",
      position: { x: 19.69627787072938, z: 6.605896962429889 },
      size: { w: 7.2715755716139645, d: 5.297003481502477 },
      rotationY: -0.08877416345810758,
    },
    {
      id: "zone-mu2mxwbp",
      label: "New Zone",
      position: { x: -21.23439289303142, z: 1.1095916612790555 },
      size: { w: 3.929150050236409, d: 2.542560762301429 },
      rotationY: -0.49261800710888715,
    },
    {
      id: "zone-mu2my9sv",
      label: "New Zone",
      position: { x: -20.851007850315305, z: -1.0257533190410444 },
      size: { w: 1.5962762071736922, d: 3 },
      rotationY: -0.5815577101385124,
    },
    {
      id: "zone-mu2myxcl",
      label: "New Zone",
      position: { x: -28.51223787019336, z: -3.820254944789929 },
      size: { w: 3, d: 6.897114074330256 },
      rotationY: 0.19907842024106587,
    },
    {
      id: "zone-mu2mzfze",
      label: "New Zone",
      position: { x: -27.39486514854674, z: -5.792308027917365 },
      size: { w: 3.73699976700778, d: 3.330845049661396 },
      rotationY: 0.20935218994387814,
    },
    {
      id: "zone-mu2n0ik7",
      label: "New Zone",
      position: { x: -11.667341916869646, z: -8.716102935447157 },
      size: { w: 5.047992645606787, d: 5.762261849461186 },
      rotationY: -0.34646651769477244,
    },
    {
      id: "zone-mu2n18mj",
      label: "New Zone",
      position: { x: 18.35523407693114, z: 13.829687781991831 },
      size: { w: 8.931168990667892, d: 7.795045983825221 },
      rotationY: -0.08903637462198086,
    },
    {
      id: "zone-mu2n2a2t",
      label: "New Zone",
      position: { x: 23.76267812082384, z: 17.521954067614125 },
      size: { w: 1.2940475604244484, d: 1.5584427205647757 },
      rotationY: 0,
    },
    {
      id: "zone-mu2n2tco",
      label: "New Zone",
      position: { x: 18.113354484842112, z: 25.286394593170357 },
      size: { w: 3, d: 6.820872950116858 },
      rotationY: -0.127587322749152,
    },
    {
      id: "zone-mu2n3a2k",
      label: "New Zone",
      position: { x: 26.253999460156113, z: 23.991522378061976 },
      size: { w: 3.4402816537132437, d: 5.114399051694369 },
      rotationY: 0,
    },
    {
      id: "zone-mu2n3vel",
      label: "New Zone",
      position: { x: 3.217136196223742, z: 23.849551289053192 },
      size: { w: 3.7461964584619003, d: 1.628201029705292 },
      rotationY: -0.07267505061672644,
    },
    {
      id: "zone-mu2n4oj6",
      label: "New Zone",
      position: { x: 3.1672528319573345, z: 28.981071892900147 },
      size: { w: 3.7091214896087408, d: 2.5981530024739743 },
      rotationY: 0,
    },
    {
      id: "zone-mu2n57hk",
      label: "New Zone",
      position: { x: -2.579989924479771, z: 29.292447044962827 },
      size: { w: 3.8084759999302875, d: 3.1817419731210967 },
      rotationY: -0.04846210791214998,
    },
    {
      id: "zone-mu2n5yxj",
      label: "New Zone",
      position: { x: -12.84288865109967, z: 18.97968874595128 },
      size: { w: 5.746012860386368, d: 7.617584608318106 },
      rotationY: 0.4735269420991639,
    },
    {
      id: "zone-mu2n6od8",
      label: "New Zone",
      position: { x: -16.351626094099654, z: 18.304402260913122 },
      size: { w: 6.266289370300243, d: 7.238712443740025 },
      rotationY: 0.5014621997142013,
    },
    {
      id: "zone-mu2n7kd1",
      label: "New Zone",
      position: { x: -21.737554736949374, z: 13.508354305641818 },
      size: { w: 3, d: 3 },
      rotationY: 0.5267848250461593,
    },
    {
      id: "zone-mu2n7x1h",
      label: "New Zone",
      position: { x: -22.852238756758144, z: 7.842513039977746 },
      size: { w: 4.337649989356654, d: 4.1225792773793835 },
      rotationY: 0.5058459029280757,
    },
    {
      id: "zone-mu2ohag3",
      label: "New Zone",
      position: { x: 6.8636192504378055, z: -16.213865393648465 },
      size: { w: 1.7923973366942845, d: 3 },
      rotationY: 0.4276178854250085,
    },
  ],

  decals: [
    {
      id: "decal-mt229hpq",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: -4.354865468870701, z: -21.51736282582655 },
      size: { w: 2, d: 2.68 },
      rotationY: 0,
      opacity: 0.64,
      hardness: 0.04,
    },
    {
      id: "decal-mt229pd7",
      label: "Newspaper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -5.722207552949357, z: -15.762383998337473 },
      size: { w: 2, d: 2.68 },
      rotationY: -0.48590476872257254,
      opacity: 0.87,
      hardness: 0.15,
    },
    {
      id: "decal-mtrnuisd",
      label: "Shadow-circle",
      textureUrl: "/decals/shadow-circle.webp",
      position: { x: 6.135471616508644, z: -2.433589474709698 },
      size: { w: 1.88702936819244, d: 2.378072030030081 },
      rotationY: 0,
      opacity: 1,
      hardness: 0.13,
    },
    {
      id: "decal-mtsfs1in",
      label: "Shadow-circle",
      textureUrl: "/decals/shadow-circle.webp",
      position: { x: -8.897333629104773, z: -0.09286555204974789 },
      size: { w: 5.880701994409316, d: 9.67375532225878 },
      rotationY: 0,
      opacity: 0.54,
      hardness: 0,
    },
    {
      id: "decal-mtsfss19",
      label: "Shadow-circle",
      textureUrl: "/decals/shadow-circle.webp",
      position: { x: -8.90446013222537, z: -0.05368302780171064 },
      size: { w: 3.1772854343607273, d: 4.395213831841567 },
      rotationY: 0,
    },
    {
      id: "decal-mtskew68-pva2",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -10.554454567244521, z: -3.837014897540917 },
      size: { w: 2.3425499999999997, d: 5.19455 },
      rotationY: 0.417094136056077,
    },
    {
      id: "decal-mtskmhbb-nw1y",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 3.775116581951954, z: -28.2074464936885 },
      size: { w: 4.34746, d: 4.34746 },
      rotationY: 0,
      opacity: 0.57,
      hardness: 0,
    },
    {
      id: "decal-mtskmwet-q9mu",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 29.508769535291865, z: -28.652656580626246 },
      size: { w: 4.12919, d: 4.405765 },
      rotationY: -0.0159374288043629,
      opacity: 0.63,
      hardness: 0,
    },
    {
      id: "decal-mtvgxhxx-bwkg",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -3.8728185987317874, z: -6.131426172124566 },
      size: { w: 9.467862569244927, d: 6.511190137698328 },
      rotationY: 1.0102021519055386,
      opacity: 0.87,
      hardness: 0,
    },
    {
      id: "decal-mtvgxuvn-qrsj",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -4.483690620209048, z: -6.572394390081399 },
      size: { w: 9.122654318510017, d: 4.381972554455198 },
      rotationY: 1.0102021519055386,
      opacity: 1,
      hardness: 0.4,
    },
    {
      id: "decal-mtwzkguf-pivf",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 6.893158599692563, z: -16.243475490943744 },
      size: { w: 2.17318843377536, d: 4.553999999999999 },
      rotationY: 0.45,
    },
    {
      id: "decal-mtwzktt2-5fvp",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 7.6847738303146285, z: -22.17846033953778 },
      size: { w: 8.169237387858978, d: 4.068373715517349 },
      rotationY: 0.4232424270756539,
      opacity: 1,
      hardness: 0.08,
    },
    {
      id: "decal-mtwzl5rl-hl0u",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 2.5939642558016267, z: -20.15450451649032 },
      size: { w: 2.2539249738540343, d: 4.553999999999999 },
      rotationY: -0.18117336218223964,
    },
    {
      id: "decal-mtwzn8hr-skll",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -18.826938230191647, z: -28.978845204190907 },
      size: { w: 3.086187597099975, d: 5.7790807646958555 },
      rotationY: 1.7600601633864406,
    },
    {
      id: "decal-mtwznnoy-huw0",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -10.06932027987727, z: -28.903214350268218 },
      size: { w: 3.1624999999999996, d: 7.452 },
      rotationY: 1.5569317002759278,
    },
    {
      id: "decal-mtwznpzd-pzty",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -29.822272177566592, z: -24.644151278269167 },
      size: { w: 3.8317999999999994, d: 11.385 },
      rotationY: -0.06635552393878996,
    },
    {
      id: "decal-mtx14sq5-olq6",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -5.42628896817148, z: 23.67915884121261 },
      size: { w: 1.9561499999999998, d: 4.3469999999999995 },
      rotationY: -0.07030639151645827,
    },
    {
      id: "decal-mtx14w5a-mtew",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 3.16978941415863, z: 23.4529225373515 },
      size: { w: 4.793782203074987, d: 3.337845409179233 },
      rotationY: 3.141593,
      opacity: 0.75,
    },
    {
      id: "decal-mtx15cza-lp8k",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 3.16978941415863, z: 27.62313527014145 },
      size: { w: 3.718381810463773, d: 0.7289521352079578 },
      rotationY: 3.141593,
      opacity: 0.51,
      hardness: 0,
    },
    {
      id: "decal-mtx15xjj-5eav",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 24.297939039689737, z: 24.151098788468573 },
      size: { w: 8.115036601003624, d: 6.775521237006304 },
      rotationY: 0.09672141071698677,
    },
    {
      id: "decal-mtx16ewz-tl8b",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 22.442808170556596, z: 22.700761614868465 },
      size: { w: 2.182351413042198, d: 5.289209309208187 },
      rotationY: 0.45031583619996235,
    },
    {
      id: "decal-mtx16tnj-8sp7",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -0.7973825492720463, z: 3.1599404557663644 },
      size: { w: 1.916152926204189, d: 3.3103108622656117 },
      rotationY: 0.07148635037583378,
      opacity: 0.62,
      hardness: 0,
    },
    {
      id: "decal-mtx17jgo-6v8y",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 9.24312694721165, z: -8.409980411830045 },
      size: { w: 2.4598499999999994, d: 5.5889999999999995 },
      rotationY: 1.35,
    },
    {
      id: "decal-mtx17ly0-n09l",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 4.0553411048902115, z: -14.263993221441739 },
      size: { w: 1.8618499999999998, d: 4.553999999999999 },
      rotationY: 0.16023563306575847,
    },
    {
      id: "decal-mtx17s70-t9hw",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 29.5810347830923, z: -23.47390620743008 },
      size: { w: 1.9239499999999998, d: 4.553999999999999 },
      rotationY: 0.5,
    },
    {
      id: "decal-mtx17uhf-4yl2",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 25.831712419623656, z: -27.936521884542678 },
      size: { w: 2.5782999999999996, d: 4.553999999999999 },
      rotationY: -0.63420645805353,
    },
    {
      id: "decal-mtx17wm9-h215",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 29.20018092191558, z: 5.892149737624013 },
      size: { w: 2.7554, d: 4.776770030306662 },
      rotationY: 3.1151930167082993,
    },
    {
      id: "decal-mu2mrgx1-ysyy",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 29.74601864206953, z: -10.433555292893155 },
      size: { w: 2.6714499999999997, d: 6.382499999999999 },
      rotationY: 0.4013709156381276,
    },
    {
      id: "decal-mu2mt71z-fgux",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -24.384424754520342, z: -11.237223834077279 },
      size: { w: 2.052405, d: 4.098599999999999 },
      rotationY: 1.1,
    },
    {
      id: "decal-mu2mtqmm-5wb9",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -26.35850489091101, z: -2.56679916767759 },
      size: { w: 2.088285, d: 5.14602 },
      rotationY: 1.7211757077266316,
    },
    {
      id: "decal-mu2muxes-8fzh",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -27.506034371398737, z: -4.201622144151622 },
      size: { w: 5.862495771323278, d: 8.779905455734161 },
      rotationY: 0.1995933283856601,
      hardness: 0.27,
    },
    {
      id: "decal-mu2mw1lh-mr2t",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -23.00626429873516, z: 7.9775511869565285 },
      size: { w: 5.902259999999999, d: 6.087409999999999 },
      rotationY: 1.01091626762373,
    },
    {
      id: "decal-mu2mwcj0-kg3d",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -21.16059216932587, z: 0.9378877880501486 },
      size: { w: 5.148082572531379, d: 3.9752531353269562 },
      rotationY: 2.642030205889753,
    },
    {
      id: "decal-mu2naswa-oq4j",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: -8.557851936790572, z: 4.309759653492331 },
      size: { w: 3.8807113714244745, d: 3.15652 },
      rotationY: 0.6524464879699593,
    },
    {
      id: "decal-mu33hlkx-44v9",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 3.4273500764844282, z: 15.084822516333098 },
      size: { w: 3.7608089326085623, d: 3.3017539278893153 },
      rotationY: -2.6418613066904966,
    },
    {
      id: "decal-mu33i6ss-krwb",
      label: "Shadow blob",
      textureUrl: "/decals/shadow-blob.webp",
      position: { x: 3.803605371040865, z: 12.312867673944305 },
      size: { w: 5.037520266183009, d: 3.66098188046947 },
      rotationY: -2.6418613066904966,
    },
  ],

  roads: [
    {
      id: "road-mtwzqvff",
      label: "Old asphalt 4",
      surface: "asphalt_old",
      points: [{ x: -0.263, z: -31.855 }, { x: -0.51, z: -19.195 }, { x: 0.355, z: -15.017 }, { x: 1.387, z: -12.543 }, { x: 2.846, z: -10.96 }, { x: 5.027, z: -8.422 }, { x: 6.774, z: -7.927 }, { x: 9.189, z: -7.521 }, { x: 10.599, z: -7.138 }, { x: 11.849, z: -6.334 }, { x: 12.559, z: -5.09 }, { x: 13.241, z: -3.475 }, { x: 13.103, z: -1.681 }, { x: 12.443, z: 0.176 }, { x: 11.363, z: 1.588 }, { x: 9.881, z: 3.55 }, { x: 9.268, z: 5.837 }, { x: 9.422, z: 7.361 }, { x: 9.481, z: 9.521 }, { x: 9.635, z: 12.41 }, { x: 9.641, z: 14.472 }, { x: 10.419, z: 16.008 }, { x: 11.425, z: 18.262 }, { x: 11.697, z: 20.131 }, { x: 11.481, z: 22.226 }, { x: 11.109, z: 23.816 }, { x: 10.335, z: 25.968 }, { x: 9.679, z: 28.205 }, { x: 9.043, z: 30.577 }, { x: 8.805, z: 31.92 }, { x: 8.715, z: 32.168 }, { x: 9.22, z: 32.759 }],
      width: 6.1,
      tileLength: 4.7,
    },
    {
      id: "road-mtwzrz2h",
      label: "Old asphalt 5",
      surface: "asphalt_old",
      points: [{ x: 17.492, z: 25.412 }, { x: 15.737, z: 25.235 }, { x: 14.934, z: 25.085 }, { x: 14.573, z: 24.734 }, { x: 14.081, z: 24.514 }, { x: 13.692, z: 24.4 }],
      width: 6,
    },
    {
      id: "road-mtx00f9q",
      label: "Masoned foot path 5",
      surface: "masonry_path",
      points: [{ x: 1.214, z: -8.27 }, { x: 0.795, z: -7.742 }, { x: 0.641, z: -6.879 }, { x: 0.871, z: -4.852 }, { x: 1.429, z: -2.064 }, { x: 2.519, z: 0.57 }, { x: 3.475, z: 2.251 }, { x: 4.791, z: 3.616 }, { x: 6.471, z: 4.732 }],
      width: 1.4,
    },
    {
      id: "road-mtx0pw0d",
      label: "Dirt path (narrow) 4",
      surface: "dirt_path",
      points: [{ x: 14.656, z: 19.929 }, { x: 16.923, z: 19.914 }, { x: 19.642, z: 19.979 }, { x: 21.832, z: 19.71 }, { x: 23.253, z: 19.26 }, { x: 25.087, z: 18.964 }, { x: 26.912, z: 19.206 }, { x: 28.862, z: 19.484 }],
      width: 1.3,
      tileLength: 1.4,
      opacity: 0.9,
    },
    {
      id: "road-mtx1c6yy",
      label: "Dirt road (wide) 5",
      surface: "dirt_road",
      points: [{ x: -3.437, z: -18.975 }, { x: -5.723, z: -19.108 }, { x: -7.396, z: -18.728 }, { x: -9.493, z: -18.067 }, { x: -11.706, z: -16.722 }, { x: -14.561, z: -14.562 }, { x: -16.556, z: -12.173 }, { x: -17.546, z: -9.277 }, { x: -17.848, z: -5.998 }, { x: -17.491, z: -3.564 }, { x: -16.8, z: -1.124 }, { x: -15.772, z: 0.69 }, { x: -14.716, z: 2.049 }, { x: -13.605, z: 3.196 }, { x: -12.459, z: 4.102 }, { x: -11.661, z: 5.034 }, { x: -11.033, z: 5.869 }, { x: -9.207, z: 9.348 }, { x: -7.996, z: 11.43 }, { x: -6.788, z: 13.505 }, { x: -5.173, z: 17.229 }, { x: -4.292, z: 19.484 }, { x: -3.655, z: 21.787 }, { x: -3.504, z: 22.917 }, { x: -3.468, z: 23.869 }, { x: -3.493, z: 24.894 }, { x: -3.691, z: 26.146 }, { x: -3.969, z: 27.323 }, { x: -4.319, z: 28.583 }, { x: -4.48, z: 29.724 }, { x: -4.569, z: 31.227 }, { x: -4.602, z: 31.814 }, { x: -4.591, z: 32.032 }],
      width: 3,
      tileLength: 5,
      opacity: 0.9,
    },
    {
      id: "road-mu2muelu",
      label: "Dirt road (wide) 6",
      surface: "dirt_road",
      points: [{ x: -19.218, z: -5.151 }, { x: -21.204, z: -4.726 }, { x: -23.188, z: -3.238 }, { x: -23.901, z: -2.707 }, { x: -24.483, z: -2.416 }, { x: -25.029, z: -2.359 }, { x: -25.596, z: -2.189 }, { x: -25.997, z: -2.167 }, { x: -26.337, z: -2.129 }, { x: -26.864, z: -1.993 }, { x: -26.996, z: -1.963 }],
      width: 3.4,
      tileLength: 3.2,
      opacity: 0.9,
    },
  ],

  cables: [
    {
      id: "grid-trunk",
      label: "Settlement Power Trunk",
      anchors: [{ position: { x: 29.509, z: -28.653 }, height: 4.69 }, { position: { x: 8.6, z: -25.5 }, height: 4.23 }, { position: { x: 3.775, z: -28.207 }, height: 4.69 }, { position: { x: -2.8, z: -19.5 }, height: 4.23 }, { position: { x: -7.2, z: -11.5 }, height: 4.23 }, { position: { x: 5.189, z: 0.71 }, height: 4.23 }, { position: { x: 13.5, z: 9.5 }, height: 4.23 }, { position: { x: 1.438, z: 19.159 }, height: 4.23 }, { position: { x: -11.102, z: 27.502 }, height: 4.69 }],
      sag: 0.6,
    },
    {
      id: "grid-overseer-spur",
      label: "Overseer Mast Spur",
      anchors: [{ position: { x: 1.438, z: 19.159 }, height: 4.23 }, { position: { x: 1.245, z: 13.552 }, height: 9.677 }],
      sag: 0.45,
    },
  ],

  spriteSpawns: [
    {
      id: "sprite-mu2pspms",
      label: "Camp Fire",
      sheet: "fire",
      position: { x: -2.877784515479906, z: 3.585182672719115 },
      positionY: 0.1,
      width: 1.3,
      height: 1.45,
      opacity: 0.7,
      color: 0x6d4f4f,
    },
    {
      id: "sprite-mu2pu2a5",
      label: "Smoke",
      sheet: "smoke",
      position: { x: -2.588684410546316, z: 3.4179843887316306 },
      positionY: 0.75,
      width: 1.2,
      height: 2.9,
      opacity: 0.49,
      color: 0xcdc4ad,
    },
    {
      id: "sprite-mu2rq9nb",
      label: "Fire",
      sheet: "fire",
      position: { x: -20.868485570275645, z: 10.587156310492286 },
      positionY: 0.8,
      width: 0.8,
      height: 0.65,
      opacity: 0.52,
      color: 0xcfafaf,
    },
    {
      id: "sprite-mu2rr1ya",
      label: "Smoke",
      sheet: "smoke",
      position: { x: -21.232810706284518, z: 10.325126646422035 },
      positionY: 0.95,
      width: 0.85,
      height: 3.6,
      opacity: 0.2,
      color: 0x8a8578,
    },
    {
      id: "sprite-mu2rslst",
      label: "Smoke",
      sheet: "smoke",
      position: { x: 23.808092897106825, z: 17.590354739146843 },
      positionY: 1.1,
      width: 1.2,
      height: 5.45,
      opacity: 0.23,
      color: 0x8a8578,
    },
    {
      id: "sprite-mu2rtvyf",
      label: "Fire",
      sheet: "fire",
      position: { x: 4.74934693699532, z: -23.08585078117064 },
      positionY: 0.8000000000000002,
      width: 0.7,
      height: 0.8,
    },
    {
      id: "sprite-mu2rv7ti",
      label: "Smoke",
      sheet: "smoke",
      position: { x: 4.739, z: -22.989 },
      positionY: 1.45,
      width: 0.55,
      height: 3.25,
      opacity: 0.41,
      color: 0x8a8578,
    },
  ],

  npcs: {
    "halvard": {
      id: "halvard",
      name: "Halvard",
      role: "Banker",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "marek": {
      id: "marek",
      name: "Old Marek",
      role: "Scrap Trader",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "iris": {
      id: "iris",
      name: "Iris",
      role: "Field Medic",
      portrait: "/portraits/npc-b.png",
      dialogRootId: "root",
    },
    "bram": {
      id: "bram",
      name: "Bram",
      role: "Cook",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "toma": {
      id: "toma",
      name: "Shade",
      role: "Gate Watch",
      portrait: "/portraits/npc-b.png",
      dialogRootId: "root",
    },
    "sergeant": {
      id: "sergeant",
      name: "Sergeant Cole",
      role: "Barracks Officer",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "finch": {
      id: "finch",
      name: "Finch",
      role: "Range Instructor",
      portrait: "/portraits/npc-b.png",
      dialogRootId: "root",
    },
    "oksana": {
      id: "oksana",
      name: "Oksana",
      role: "Quartermaster",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "rask": {
      id: "rask",
      name: "Elder Rask",
      role: "Settlement Leader",
      portrait: "/portraits/npc-b.png",
      dialogRootId: "root",
    },
    "tower-guard-gate": {
      id: "tower-guard-gate",
      name: "Tower Guard",
      role: "Villager",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "home": {
      id: "home",
      name: "Your Home",
      role: "Shelter",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
    "yulia": {
      id: "yulia",
      name: "Yulia",
      role: "Farmhand",
      portrait: "/portraits/npc-b.png",
      dialogRootId: "root",
    },
    "test-weps1": {
      id: "test-weps1",
      name: "test-weps1",
      role: "Villager",
      portrait: "/portraits/npc-a.png",
      dialogRootId: "root",
    },
  },

  dialog: {
    "marek": {
      "root": {
        id: "root",
        npcId: "marek",
        text: "You. You’re the one from the Sleeping Corners. You need scrap, or you got scrap to sell?",
        options: [
          { label: "What do you have?", to: "wares" },
          { label: "Who runs this place?", to: "lore" },
          { label: "[Leave]", to: null },
          { label: "Let’s trade.", to: "trade" },
        ],
      },
      "wares": {
        id: "wares",
        npcId: "marek",
        text: "Wire, bolts, half a circuit board if you’re lucky. Come find me at the stall if you want to deal properly.",
        options: [
          { label: "Fair enough.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "trade": {
        id: "trade",
        npcId: "marek",
        text: "Let’s see what you’ve got.",
        options: [
          { label: "[Done]", to: null },
        ],
      },
      "lore": {
        id: "lore",
        npcId: "marek",
        text: "Nobody \"runs\" New Ashford. We earn our keep. You earn reputation, you get a Zone. Simple as the old world was not.",
        options: [
          { label: "Tell me more.", to: "wares" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "iris": {
      "root": {
        id: "root",
        npcId: "iris",
        text: "Hold still — you’re not bleeding, good. What do you need?",
        options: [
          { label: "Got any medicine?", to: "meds" },
          { label: "I’m fine.", to: null },
        ],
      },
      "meds": {
        id: "meds",
        npcId: "iris",
        text: "Antibiotics are rationed. Bring me clean cloth and I’ll patch whoever you drag in. That’s the deal.",
        options: [
          { label: "Understood.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "bram": {
      "root": {
        id: "root",
        npcId: "bram",
        text: "Smell that? Real broth. First hot meal some of these people have had in weeks.",
        options: [
          { label: "Any to spare?", to: "food" },
          { label: "[Leave]", to: null },
        ],
      },
      "food": {
        id: "food",
        npcId: "bram",
        text: "Spare? Ha. You pull your weight, you eat. Bring me something for the pot and we’ll talk.",
        options: [
          { label: "Maybe later.", to: null },
        ],
      },
    },
    "halvard": {
      "root": {
        id: "root",
        npcId: "halvard",
        text: "Gold in, Cash out. I don’t do it the other way round — nobody does.",
        options: [
          { label: "Let’s trade.", to: null },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "toma": {
      "root": {
        id: "root",
        npcId: "toma",
        text: "Gate’s closed to outsiders after dark. You’re one of ours, so — what do you need?",
        options: [
          { label: "What’s beyond the wall?", to: "outside" },
          { label: "Any trouble lately?", to: "trouble" },
          { label: "[Leave]", to: null },
        ],
      },
      "outside": {
        id: "outside",
        npcId: "toma",
        text: "Whatever the map shows you. I just make sure it doesn’t follow you back in.",
        options: [
          { label: "Fair.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "trouble": {
        id: "trouble",
        npcId: "toma",
        text: "Quiet week. Quiet weeks make me nervous, if I’m honest.",
        options: [
          { label: "Stay sharp.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "sergeant": {
      "root": {
        id: "root",
        npcId: "sergeant",
        text: "Cole. You look like you can still hold a line. What is it?",
        options: [
          { label: "How’s the garrison?", to: "garrison" },
          { label: "Any work for me?", to: "work" },
          { label: "[Leave]", to: null },
        ],
      },
      "garrison": {
        id: "garrison",
        npcId: "sergeant",
        text: "Understaffed and underfed, same as everywhere. We hold what we have.",
        options: [
          { label: "Understood.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "work": {
        id: "work",
        npcId: "sergeant",
        text: "Not through me — not yet. Prove yourself out there first.",
        options: [
          { label: "I will.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "finch": {
      "root": {
        id: "root",
        npcId: "finch",
        text: "Range is standing! Timber off the old school hall. Careful with that stance, though — you'll dislocate a shoulder before you hit anything.",
        options: [
          { label: "Show me.", to: "lesson" },
          { label: "You built all this?", to: "built" },
          { label: "I'm fine, thanks.", to: null },
        ],
      },
      "lesson": {
        id: "lesson",
        npcId: "finch",
        text: "Feet apart, weight forward, and stop holding your breath. Ammo's still rationed, so it's dry drills and paper — but it's a range. Six months ago we shot at a fence post.",
        options: [
          { label: "Noted.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "built": {
        id: "built",
        npcId: "finch",
        text: "Me, and everyone I could guilt into carrying a beam. Rask signed it off once I pointed out we had rifles and nobody who could use them.",
        options: [
          { label: "Sensible.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "oksana": {
      "root": {
        id: "root",
        npcId: "oksana",
        text: "Garrison eats before anyone else, those are the rules. What do you need?",
        options: [
          { label: "Can I get a ration?", to: "ration" },
          { label: "Just looking.", to: null },
        ],
      },
      "ration": {
        id: "ration",
        npcId: "oksana",
        text: "Not without a chit from the sergeant. Talk to Cole first.",
        options: [
          { label: "I’ll ask him.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "rask": {
      "root": {
        id: "root",
        npcId: "rask",
        text: "New Ashford stands because people work. You've been seen doing that. Keep at it and there'll be a place for you here — a proper one.",
        options: [
          { label: "What kind of place?", to: "zone" },
          { label: "What happened here?", to: "history" },
          { label: "Who else should I know?", to: "people" },
          { label: "[Leave]", to: null },
        ],
      },
      "zone": {
        id: "zone",
        npcId: "rask",
        text: "A Zone. Your own patch to run — smithing, salvage, the fields, whichever way your hands lean. You earn it. Nobody here is given anything.",
        options: [
          { label: "How do I earn it?", to: "earn" },
          { label: "[Leave]", to: null },
        ],
      },
      "earn": {
        id: "earn",
        npcId: "rask",
        text: "Reputation. Do the work nobody wants, and do it twice. I'll know when you're ready — that is not flattery, it is simply how small a place this is.",
        options: [
          { label: "Understood.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "history": {
        id: "history",
        npcId: "rask",
        text: "Ashford was a market town. Forty thousand people, once. The well is why we're still here — it never ran dry, not through the worst of it. Everything else we built around it.",
        options: [
          { label: "And the wall?", to: "wall" },
          { label: "[Leave]", to: null },
        ],
      },
      "wall": {
        id: "wall",
        npcId: "rask",
        text: "Went up in a fortnight, after the second winter. Cole runs the watch on it now. It is ugly and it holds, which is the whole of our philosophy.",
        options: [
          { label: "Fair.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "people": {
        id: "people",
        npcId: "rask",
        text: "Iris at the medbay — she keeps us breathing. Oksana holds the stores and the rota. Marek trades scrap and gossip in equal weight. Finch has his range now, and won't stop telling people about it.",
        options: [
          { label: "Noted.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "tower-guard-gate": {
      "root": {
        id: "root",
        npcId: "tower-guard-gate",
        text: "Tower Guard has nothing to say yet.",
        options: [
        ],
      },
    },
    "home": {
      "root": {
        id: "root",
        npcId: "home",
        text: "Not much, but it's yours. Dry roof, four walls, and nobody bothering you.",
        options: [
          { label: "Rest a while.", to: "rest" },
          { label: "[Leave]", to: null },
        ],
      },
      "rest": {
        id: "rest",
        npcId: "home",
        text: "You sit for a minute. It's quiet here, for now.",
        options: [
          { label: "That's enough for now.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "yulia": {
      "root": {
        id: "root",
        npcId: "yulia",
        text: "Mind the rows. Took two seasons to get anything to come up in this dirt.",
        options: [
          { label: "What grows here?", to: "crops" },
          { label: "Need a hand?", to: "help" },
          { label: "[Leave]", to: null },
        ],
      },
      "crops": {
        id: "crops",
        npcId: "yulia",
        text: "Potatoes, mostly. Beans when the rain behaves. It's not much, but it's ours — nobody upriver decides what we eat.",
        options: [
          { label: "Fair enough.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
      "help": {
        id: "help",
        npcId: "yulia",
        text: "Always. Talk to Oksana though — she keeps the work rota. I just keep things alive.",
        options: [
          { label: "I'll find her.", to: "root" },
          { label: "[Leave]", to: null },
        ],
      },
    },
    "test-weps1": {
      "root": {
        id: "root",
        npcId: "test-weps1",
        text: "test-weps1 has nothing to say yet.",
        options: [
        ],
      },
    },
  },
};
